export const LOAN_URL = (id) => `loan/${id}/ac4f4d6d-6477-4cb8-ba02-c27b065d08fc`;
export const BORROWER_URL = (id) => `/borrower/${id}`;

// Status badge appearance map
export const STATUS_MAP = {
  "Active":       { cls: "status--active", label: "Active" },
  "Under review": { cls: "status--warn",   label: "Under review" },
  "Closed":       { cls: "status--muted",  label: "Closed" },
};

export const RISK_GRADE_MAP = {
  "Pass":            { label: "Pass",            color: "#16a34a", bg: "rgba(22,163,74,0.12)" },
  "Watch":           { label: "Watch",           color: "#b45309", bg: "rgba(180,83,9,0.12)" },
  "Special Mention": { label: "Special Mention", color: "#ea580c", bg: "rgba(234,88,12,0.12)" },
  "Sub-standard":    { label: "Sub-standard",    color: "#dc2626", bg: "rgba(220,38,38,0.12)" },
  "Doubtful":        { label: "Doubtful",        color: "#9f1239", bg: "rgba(159,18,57,0.12)" },
  "Loss":            { label: "Loss",            color: "#6b7280", bg: "rgba(107,114,128,0.15)" },
};

export const AUDIT_FIELD_LABEL_MAP = {
  Name:                     "Name",
  Description:              "Description",
  Notes:                    "Notes",
  InternalRiskGrade:        "Internal Risk Grade",
  AccountBalanceOutsideDF:  "Account Balance Outside DF",
  ExistingLimitOutsideDF:   "Existing Limit Outside DF",
  ProposedLimitOutsideDF:   "Proposed Limit Outside DF",
};

// Sortable field keys used for list table
export const SORT_FIELDS = {
  NAME:           "name",

  TOTAL_EXPOSURE: "totalExposure",
  HTB_APPROVED:   "htbApproved",
};

export const DEFAULT_SORT = { field: SORT_FIELDS.NAME, order: "asc" };

export const ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50];

// List table column definitions
export const LIST_COLUMNS = [
  { label: "Group ID",            field: "id",                       sortable: false, align: "left",   minWidth: 140 },
  { label: "Group Name",          field: SORT_FIELDS.NAME,           sortable: true,  align: "left",   minWidth: 200 },
  { label: "Total Exposure (£)",  field: SORT_FIELDS.TOTAL_EXPOSURE, sortable: true,  align: "right",  minWidth: 150 },
  { label: "Description",         field: "description",              sortable: false, align: "left",   minWidth: 240 },
  { label: "Notes",               field: "notes",                    sortable: false, align: "left",   minWidth: 240 },
  // { label: "CARS Approved (£)",   field: SORT_FIELDS.HTB_APPROVED,   sortable: true,  align: "right",  minWidth: 150 },
  // { label: "Risk Grade",          field: "internalrisk",             sortable: false, align: "left",   minWidth: 130 },
  { label: "Created",             field: "createdBy",                sortable: false, align: "left",   minWidth: 180 },
  { label: "Modified",            field: "modifiedBy",               sortable: false, align: "left",   minWidth: 180 },
  { label: "Action",              field: "action",                   sortable: false, align: "center", minWidth: 130 },
];

// All user-visible UI strings
export const STRINGS = {
  DEFAULT_TITLE:             "Exposure Groups",
  LIST_SUBTITLE:             "Select an exposure group below to view its detailed borrowers, loans, and credit risk exposures.",
  SEARCH_LABEL:              "Search by name or ID",
  NO_RESULTS:                "No exposure groups found matching your search.",
  LOADING_EMPTY:             "No exposure groups available.",
  SWITCH_GROUP:              "Switch group",
  BACK_TO_LIST:              "Back to List",
  FILTER:                    "Filter",
  REVIEWED_STATUS:           "Reviewed",
  VIZ_TITLE:                 "Exposure group - borrower & loan linkage",
  VIZ_SUBTITLE:              "All linked entities are clickable. Hover any borrower to trace their loans.",
  LEGEND_G_TO_B:             "Group → Borrower",
  LEGEND_B_TO_L:             "Borrower → Loan",
  LEGEND_HINT:               "Hover a borrower or loan to trace its links",
  VIEW_DETAILS:              "View Details",
  COL_BORROWERS:             "BORROWERS",
  COL_LOANS:                 "LOANS",
  COL_EXPOSURE_GROUP:        "EXPOSURE GROUP",
  AUDIT_LOG:                 "Audit Log",
  AUDIT_TOOLTIP:             "View Audit Log",
  AUDIT_NO_RECORDS:          "No audit records found.",
  AUDIT_LOAD_ERROR:          "Failed to load audit log. Please try again.",
  AUDIT_COL_ACTION:          "Action",
  AUDIT_COL_FIELD:           "Field",
  AUDIT_COL_OLD:             "Old Value",
  AUDIT_COL_NEW:             "New Value",
  AUDIT_COL_BY:              "Changed By",
  AUDIT_COL_DATE:            "Date",
  EDIT_GROUP:                "Edit Group",
  EDIT_TITLE:                "Edit Exposure Group",
  EDIT_SAVE:                 "Save Changes",
  EDIT_SUCCESS:              "Exposure Group updated successfully.",
  EDIT_ERROR:                "Failed to update Exposure Group. Please try again.",
  ADD_TITLE:                 "Add Exposure Group",
  ADD_SAVE:                  "Create Group",
  ADD_SUCCESS:               "Exposure Group created successfully.",
  ADD_ERROR:                 "Failed to create Exposure Group. Please try again.",
  FIELD_DESCRIPTION:         "Description",
  FIELD_NOTES:               "Notes",
  FIELD_ACCT_BAL:            "Account Balance Outside DF",
  FIELD_EXISTING_LIMIT:      "Existing Limit Outside DF",
  FIELD_PROPOSED_LIMIT:      "Proposed Limit Outside DF",
  FIELD_INTERNAL_RISK:       "Internal Risk Grade",

  // Group Exposure Table
  TABLE_CATEGORY_PREFIX:     "CREDIT PAPER",
  TABLE_TITLE:               "Group Exposure",
  TABLE_SUBTITLE:            "Group-level exposure metrics with user-adjustable Outside DF inputs",
  EXPORT:                    "Export",
  COL_FINANCIAL_ITEM:        "Financial Item",
  COL_SUBJECT_LOAN:          "Subject Loan",
  COL_ACCOUNT_EXPOSURE:      "Account Exposure (Within DF)",
  COL_ACCOUNT_EXPOSURE_SUB:  "Connected loans in group",
  COL_OUTSIDE_DF:            "Outside DF",
  COL_OUTSIDE_DF_SUB:        "User Input",
  COL_HTB_TOTAL:             "HTB Total",
  COL_HTB_TOTAL_SUB:         "Sum",
  ACCOUNT_BALANCE:           "Account Balance",
  ACCOUNT_BALANCE_SUB:       "Current outstanding",
  EXISTING_LIMIT:            "Existing Limit",
  EXISTING_LIMIT_SUB:        "Approved facility ceiling",
  PROPOSED_LIMIT:            "Proposed Limit",
  PROPOSED_LIMIT_SUB:        "Including new facility",
  SUBJECT_A1_HINT:           "Always 0 before CARS approval",
  SUBJECT_A2_HINT:           "Always 0",
  // ACCOUNT_EXP_FORMULA:       (n) => `Σ of ${n} open loan${n === 1 ? "" : "s"} in group`,
  // ACCOUNT_LIMIT_FORMULA:     "CARS approved across group",
  // ACCOUNT_PROPOSED_FORMULA:  "CARS approved (same as A5)",
  ACCOUNT_EXP_FORMULA:       () => "",
  ACCOUNT_LIMIT_FORMULA:     "",
  ACCOUNT_PROPOSED_FORMULA:  "",

  // Director pending review warning
  DIRECTOR_WARNING_TITLE:    "Director pending review — action required",
  DIRECTOR_WARNING_TITLE_N:  (n) => `${n} directors pending review — action required`,
  DIRECTOR_WARNING_SUBTITLE: "These directors already exist in other exposure groups. Review and approve or reject from the Director Approval Screen.",
  DIRECTOR_WARNING_VIA:      "via",
  DIRECTOR_WARNING_DOB:      "DOB",
  DIRECTOR_WARNING_CTA:      "Go to approval screen",
  BORROWER_PAGE_URL:         "borrower",
  // Template (layout) id for the Director Approval screen. Constant across all
  // entry points (Company House, Exposure Group, Personal Declaration, …):
  // /borrower/{borrowerId}/{DIRECTOR_APPROVAL_TEMPLATE_ID}
  DIRECTOR_APPROVAL_TEMPLATE_ID: "37d4f096-c5f6-4744-9167-a5c9611e6cce",
};
